


// // src/appservices/store.js

// import create from 'zustand';
// import { CalendarManager } from './AppManager';

// const useStore = create((set, get) => ({
//   // User and Business State
//   user: null,
//   stripeCustomerId: null,
//   businessId: null,
//   datastoreId: null,

//   // Loading and Error States
//   isLoading: false,
//   error: null,

//   // Subscription and Onboarding
//   subscriptionStatus: null, // 'active' | 'trial' | 'pending' | 'canceled'
//   onboardComplete: null, // Boolean to track onboarding completion
//   paymentInProgress: false, // Boolean to track payment process

//   // Documentation State
//   documents: [],
//   instructions: '',

//   // Summary Data
//   summaryData: {},
//   summaryTimeFrame: 'week',

//   // User Settings
//   userSettings: {},

//   // Action Board Data
//   userActions: [],
//   aiActions: [],

//   // Calendar State
//   events: [],
//   calendarId: null,


//   // Subscription Plan State
//   selectedPlan: null, // Selected plan ('Home' or 'Business')
//   selectedPriceId: null, // Price ID of the selected plan

//   // Setters for Plan and Price ID
//   setSelectedPlan: (plan) => set({ selectedPlan: plan }),
//   setSelectedPriceId: (priceId) => set({ selectedPriceId: priceId }),

//   // Setters for Subscription and Onboarding
//   setSubscriptionStatus: (status) => set({ subscriptionStatus: status }),
//   setOnboardComplete: (status) => set({ onboardComplete: status }),
//   setPaymentInProgress: (inProgress) => set({ paymentInProgress: inProgress }),

//   // Setters for User and Business
//   setUser: (user) => set({ user }),
//   setBusinessId: (businessId) => set({ businessId }),
//   setDatastoreId: (datastoreId) => set({ datastoreId }),

//   // Loading and Error State Actions
//   setIsLoading: (isLoading) => set({ isLoading }),
//   setError: (error) => set({ error }),

//   // Calendar Management
//   setCalendarId: (id) => set({ calendarId: id }),
//   loadEvents: async () => {
//     const calendarId = get().calendarId;
//     if (!calendarId) return;
//     const manager = new CalendarManager('https://your-server-api.com');
//     const events = await manager.listEvents(calendarId);
//     set({ events });
//   },
//   createEvent: async (eventData) => {
//     const calendarId = get().calendarId;
//     const manager = new CalendarManager('https://your-server-api.com');
//     await manager.manageEvents(calendarId, 'create', null, eventData);
//     await get().loadEvents();
//   },
//   updateEvent: async (eventId, eventData) => {
//     const calendarId = get().calendarId;
//     const manager = new CalendarManager('https://your-server-api.com');
//     await manager.manageEvents(calendarId, 'update', eventId, eventData);
//     await get().loadEvents();
//   },
//   deleteEvent: async (eventId) => {
//     const calendarId = get().calendarId;
//     const manager = new CalendarManager('https://your-server-api.com');
//     await manager.manageEvents(calendarId, 'delete', eventId);
//     await get().loadEvents();
//   },

//   // User Actions Management
//   setUserActions: (actions) => set({ userActions: actions }),
//   addUserAction: (action) => set((state) => ({ userActions: [...state.userActions, action] })),
//   updateUserAction: (id, data) =>
//     set((state) => ({
//       userActions: state.userActions.map((action) =>
//         action.id === id ? { ...action, ...data } : action
//       ),
//     })),
//   removeUserAction: (id) =>
//     set((state) => ({ userActions: state.userActions.filter((action) => action.id !== id) })),

//   // AI Actions Management
//   setAiActions: (actions) => set({ aiActions: actions }),
//   addAiAction: (action) => set((state) => ({ aiActions: [...state.aiActions, action] })),
//   updateAiAction: (id, data) =>
//     set((state) => ({
//       aiActions: state.aiActions.map((action) =>
//         action.id === id ? { ...action, ...data } : action
//       ),
//     })),
//   removeAiAction: (id) =>
//     set((state) => ({ aiActions: state.aiActions.filter((action) => action.id !== id) })),

//   // Documentation Actions
//   setDocuments: (documents) => set({ documents }),
//   addDocument: (document) =>
//     set((state) => ({ documents: [...state.documents, document] })),
//   updateDocument: (id, data) =>
//     set((state) => ({
//       documents: state.documents.map((doc) =>
//         doc.id === id ? { ...doc, ...data } : doc
//       ),
//     })),
//   removeDocument: (id) =>
//     set((state) => ({ documents: state.documents.filter((doc) => doc.id !== id) })),
//   setInstructions: (instructions) => set({ instructions }),

//   // Stripe Integration
//   setStripeCustomerId: (customerId) => set({ stripeCustomerId: customerId }),

//   // Profile Management
//   userProfile: null,
//   businessProfile: null,
//   setUserProfile: (profile) => set({ userProfile: profile }),
//   setBusinessProfile: (profile) => set({ businessProfile: profile }),
// }));

// export default useStore;

import create from 'zustand';
import {
  doc,
  collection,
  onSnapshot,
  setDoc,
  getDoc,
  serverTimestamp,
  writeBatch,
} from 'firebase/firestore';
import { firestore } from './firebase';
import { CalendarManager } from './AppManager';

const useStore = create((set, get) => ({
  // User and Business State
  user: null,
  stripeCustomerId: null,
  businessId: null,
  datastoreId: null,

  // Loading and Error States
  isLoading: false,
  error: null,

  // Subscription and Onboarding
  subscriptionStatus: null,
  onboardComplete: null,
  paymentInProgress: false,

  // Documentation State
  documents: [],
  instructions: '',

  // Summary Data
  summaryData: {},
  summaryTimeFrame: 'week',

  // User Settings
  userSettings: {},

  // Action Board Data
  userActions: [],
  aiActions: [],

  // Calendar State
  events: [],
  calendarId: null,

  // Subscription Plan State
  selectedPlan: null,
  selectedPriceId: null,

  // Setters for Plan and Price ID
  setSelectedPlan: (plan) => set({ selectedPlan: plan }),
  setSelectedPriceId: (priceId) => set({ selectedPriceId: priceId }),

  // Setters for Subscription and Onboarding
  setSubscriptionStatus: (status) => set({ subscriptionStatus: status }),
  setOnboardComplete: (status) => set({ onboardComplete: status }),
  setPaymentInProgress: (inProgress) => set({ paymentInProgress: inProgress }),

  // Setters for User and Business
  setUser: (user) => set({ user }),
  setBusinessId: (businessId) => set({ businessId }),
  setDatastoreId: (datastoreId) => set({ datastoreId }),

  // Loading and Error State Actions
  setIsLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),

  // Calendar Management
  setCalendarId: (id) => set({ calendarId: id }),
  loadEvents: async () => {
    const calendarId = get().calendarId;
    if (!calendarId) return;
    const manager = new CalendarManager('https://your-server-api.com');
    const events = await manager.listEvents(calendarId);
    set({ events });
  },

  // Firestore Synchronization
  syncToFirestore: async () => {
    const businessId = get().businessId;
    if (!businessId) {
      console.error('No business ID found for Firestore sync.');
      return;
    }

    const profilePath = `/Businesses/${businessId}/profile`;
    const profileData = {
      user: get().user,
      stripeCustomerId: get().stripeCustomerId,
      datastoreId: get().datastoreId,
      subscriptionStatus: get().subscriptionStatus,
      onboardComplete: get().onboardComplete,
      documents: get().documents,
      instructions: get().instructions,
      summaryData: get().summaryData,
      summaryTimeFrame: get().summaryTimeFrame,
      userSettings: get().userSettings,
      userActions: get().userActions,
      aiActions: get().aiActions,
      events: get().events,
      selectedPlan: get().selectedPlan,
      selectedPriceId: get().selectedPriceId,
      updatedAt: serverTimestamp(),
    };

    try {
      set({ isLoading: true });
      await setDoc(doc(firestore, profilePath), profileData);
      console.log(`Data synced to Firestore at ${profilePath}`);
    } catch (error) {
      console.error('Error syncing to Firestore:', error);
      set({ error: 'Failed to sync data to Firestore.' });
    } finally {
      set({ isLoading: false });
    }
  },

  loadFromFirestore: async () => {
    const businessId = get().businessId;
    if (!businessId) {
      console.error('No business ID found for Firestore load.');
      return;
    }

    const profilePath = `/Businesses/${businessId}/profile`;
    try {
      set({ isLoading: true });
      const docSnap = await getDoc(doc(firestore, profilePath));
      if (docSnap.exists()) {
        const data = docSnap.data();
        console.log(`Data loaded from Firestore at ${profilePath}`, data);

        // Update Zustand state with loaded data
        set({
          user: data.user || null,
          stripeCustomerId: data.stripeCustomerId || null,
          datastoreId: data.datastoreId || null,
          subscriptionStatus: data.subscriptionStatus || null,
          onboardComplete: data.onboardComplete || null,
          documents: data.documents || [],
          instructions: data.instructions || '',
          summaryData: data.summaryData || {},
          summaryTimeFrame: data.summaryTimeFrame || 'week',
          userSettings: data.userSettings || {},
          userActions: data.userActions || [],
          aiActions: data.aiActions || [],
          events: data.events || [],
          selectedPlan: data.selectedPlan || null,
          selectedPriceId: data.selectedPriceId || null,
        });
      } else {
        console.warn(`No document found at ${profilePath}`);
      }
    } catch (error) {
      console.error('Error loading from Firestore:', error);
      set({ error: 'Failed to load data from Firestore.' });
    } finally {
      set({ isLoading: false });
    }
  },

  // Documentation Management
  setDocuments: (documents) => set({ documents }),
  addDocument: (document) =>
    set((state) => ({ documents: [...state.documents, document] })),
  updateDocument: (id, data) =>
    set((state) => ({
      documents: state.documents.map((doc) =>
        doc.id === id ? { ...doc, ...data } : doc
      ),
    })),
  removeDocument: (id) =>
    set((state) => ({
      documents: state.documents.filter((doc) => doc.id !== id),
    })),

  // Stripe Integration
  setStripeCustomerId: (customerId) => set({ stripeCustomerId: customerId }),

  // Profile Management
  userProfile: null,
  businessProfile: null,
  setUserProfile: (profile) => set({ userProfile: profile }),
  setBusinessProfile: (profile) => set({ businessProfile: profile }),
}));

export default useStore;
